import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Component bảo vệ route, chỉ cho phép người dùng đã đăng nhập truy cập
 * Nếu chưa đăng nhập, chuyển hướng về trang đăng nhập
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Kiểm tra xem người dùng đã đăng nhập chưa
  // Đây chỉ là triển khai đơn giản, thực tế cần sử dụng useAuth hook hoặc context
  const isAuthenticated = localStorage.getItem('token') || sessionStorage.getItem('token');

  if (!isAuthenticated) {
    // Nếu chưa đăng nhập, chuyển hướng về trang đăng nhập
    return <Navigate to="/login" replace />;
  }

  // Nếu đã đăng nhập, hiển thị component con
  return <>{children}</>;
};

export default ProtectedRoute; 